(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("manageCategories", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/exams/manageCategoriesView.html",
            controller: ["examResource", "$scope", "$state", "$stateParams", "messageService", ManageCategoriesCtrl],
            controllerAs: "vm"
        };
        function ManageCategoriesCtrl(examResource, $scope, $state, $stateParams, messageService) {
            var vm = this;
            vm.number = $stateParams.number;
            vm.currentState = $state.current.name;
            vm.dataLoaded = false;
            vm.loading = true;
            examResource.getManageExamCategoriesViewModel({ number: vm.number }, function (model) {
                vm.model = model;
                vm.dataLoaded = true;
                vm.loading = false;
            }, function (errorData) {
                messageService.error(errorData);
            });
            vm.sortableOptions = {
                handle: ".fa-bars",
                axis: "y",
                stop: function () {
                    vm.updateOrder();
                }
            };
            vm.updateOrder = function () {
                vm.newOrder = [];
                for (var i = 1; i <= vm.model.examCategories.length; i++) {
                    vm.model.examCategories[i - 1].order = i;
                    vm.newOrder.push({
                        "id": vm.model.examCategories[i - 1].id,
                        "order": vm.model.examCategories[i - 1].order
                    });
                }
                examResource.reorderExamCategories({
                    number: vm.number, examCategories: vm.newOrder
                }, function () {
                    messageService.success("common.changesSaved");
                }, function (error) {
                    messageService.error(error);
                });
            };
            vm.rowClass = function (category) {
                return category.questions > category.bankSize ? "text-danger" : "";
            };
            vm.goToQuestions = function (categoryNumber) {
                $state.go("main.learningItems.manageExamCategoryQuestions", { number: vm.number, categoryNumber: categoryNumber });
            };
            vm.editCategory = function (category) {
                $state.go("main.learningItems.editExamCategory", { number: vm.number, categoryNumber: category.number });
                //console.log(category);
            };
            $scope.$on("reloadCategories", function () {
                examResource.getManageExamCategoriesViewModel({
                    number: vm.number
                }, function (model) {
                    vm.model = model;
                });
            });
        }
    });
}());
